<template>
  <div>
    
  </div>
</template>
<script>
export default {
  name:"selectMaterial",
  data(){
    return{

    }
  },
  mounted(){

  },
  methods:{

  },
}
</script>
<style lang="less">

</style>